import React from 'react';
import { useDrag, useDrop } from 'react-dnd';

// copied nearly character-for-character from the ant docs: https://ant.design/components/transfer/#components-transfer-demo-table-transfer
export const DragableBodyRow = ( { index, rowDrop, className, style, ...restProps } ) => {
    const ref = React.useRef();
    const [ { isOver, dropClassName }, drop ] = useDrop( {
        accept: 'DragableBodyRow',
        collect: monitor => {
            const { index: dragIndex } = monitor.getItem() || {};
            if ( dragIndex === index ) {
                return {};
            }
            return {
                isOver: monitor.isOver(),
                dropClassName: dragIndex < index ? ' drop-over-downward' : ' drop-over-upward',
            };
        },
        drop: item => {
            rowDrop( item.index, index );
        },
    } );
    const [ , drag ] = useDrag( {
        item: { type: 'DragableBodyRow', index },
        collect: monitor => ( {
            isDragging: monitor.isDragging(),
        } ),
    } );
    drop( drag( ref ) );
    return (
        <tr
            ref={ ref }
            className={ `${ className }${ isOver ? dropClassName : '' } draggable` }
            style={ { cursor: 'move', ...style } }
            { ...restProps }
        />
    );
};
